<div class="persistent-cache-container" loading-spin [isLoading]="reloading" [loadingSize]="'big'">
    <div class="row-btn">
        <label class="title">{{'adminConsole.persistent_cache' | stringLiterals}}</label>
        <button class="btn" (click)="onClickPurgeAll($event, 'metadata')" tam-button
            [tamType]="'primary'">{{'adminConsole.purge_all_metadata' | stringLiterals}}
        </button>
        <button class="btn" (click)="onClickPurgeAll($event, 'files')" tam-button
            [tamType]="'primary'">{{'adminConsole.purge_all_files' | stringLiterals}}
        </button>
        <button class="btn" (click)="onClickPurgeAll($event, 'all')" tam-button
            [tamType]="'primary'">{{'adminConsole.purge_all' | stringLiterals}}
        </button>
    </div>
    <div class="no-data" [style.display]="noDataStyle">
        <span>{{'adminConsole.no_data_found' | stringLiterals}}</span>
    </div>
    <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-balham" [columnDefs]="columnDefs"
        [rowData]="rowData" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</div>